<div class="input-file-container flex-row">
	<button valgButton color="text-only-without-padding" (click)="onClick()">{{placeholder | translate}}</button>
	<div class="text text--medium ml-5" *ngFor="let file of files; let i = index">
		<div class="text text--medium" *ngIf="file">{{file.name}}
			<button class="remove-file-button" (click)="removeFile(i)">
				<mat-icon  [svgIcon]="SvgIcon.Close" ></mat-icon>
			</button>
		</div>
	</div>
	<input #input [id]="id" type="file" multiple (change)="onInputChange($event)"/>
</div>

